@if (components$ | async; as components) {
  <ng-container>
    @for (component of components; track component; let i = $index) {
      <button [class.active]="i === activeTabNum" (click)="select(i, $event)">
        {{ component.title | transloco: { param: tabTitleParams[i] | async } }}
        <fa-icon
          [icon]="i === activeTabNum ? collapseIcon : expandIcon"
        ></fa-icon>
      </button>
      <div [class.active]="i === activeTabNum">
        @if (component.uid === 'ProductSpecsTabComponent') {
          <boels-product-attributes
            [componentData]="componentData"
          ></boels-product-attributes>
        }
        @if (component.uid === 'productAccTabComponent') {
          <boels-product-acc-tab
            [componentData]="componentData"
          ></boels-product-acc-tab>
        }
        @if (component.uid === 'ProductBimTabComponent') {
          <boels-product-bim-tab
            [componentData]="componentData"
          ></boels-product-bim-tab>
        }
      </div>
    }
  </ng-container>
}
